// Premium category-based backgrounds for scenes (Apple Home style)
// Subtle gradients with premium feel - no loud images, just sophisticated colors

export const SCENE_BACKGROUNDS = {
  general: {
    gradient: 'from-slate-50 to-slate-100',
    iconBg: 'bg-slate-100/80',
    iconColor: 'text-slate-600',
    accent: '#64748b'
  },

  morning: {
    gradient: 'from-orange-100 via-amber-50 to-yellow-100',
    iconBg: 'bg-orange-200/80',
    iconColor: 'text-orange-700',
    accent: '#f59e0b'
  },

  evening: {
    gradient: 'from-indigo-900 via-purple-900 to-slate-900',
    iconBg: 'bg-indigo-500/20',
    iconColor: 'text-indigo-300',
    accent: '#6366f1'
  },

  movie: {
    gradient: 'from-slate-900 via-slate-800 to-red-900/20',
    iconBg: 'bg-red-500/20',
    iconColor: 'text-red-400',
    accent: '#ef4444'
  },

  party: {
    gradient: 'from-purple-600 via-pink-600 to-red-500',
    iconBg: 'bg-white/20',
    iconColor: 'text-white',
    accent: '#ec4899'
  },

  sleep: {
    gradient: 'from-indigo-950 via-purple-950 to-slate-950',
    iconBg: 'bg-indigo-500/30',
    iconColor: 'text-indigo-300',
    accent: '#8b5cf6'
  },

  away: {
    gradient: 'from-slate-200 via-slate-100 to-blue-50',
    iconBg: 'bg-slate-300/80',
    iconColor: 'text-slate-600',
    accent: '#475569'
  },

  welcome: {
    gradient: 'from-amber-100 via-orange-100 to-yellow-100',
    iconBg: 'bg-amber-200/80',
    iconColor: 'text-amber-700',
    accent: '#f59e0b'
  },

  work: {
    gradient: 'from-blue-50 via-indigo-50 to-slate-50',
    iconBg: 'bg-blue-200/80',
    iconColor: 'text-blue-700',
    accent: '#3b82f6'
  },

  dinner: {
    gradient: 'from-amber-200 via-orange-200 to-yellow-200',
    iconBg: 'bg-amber-300/80',
    iconColor: 'text-amber-800',
    accent: '#f97316'
  },

  relax: {
    gradient: 'from-purple-100 via-pink-100 to-rose-100',
    iconBg: 'bg-purple-200/80',
    iconColor: 'text-purple-700',
    accent: '#a855f7'
  }
};

export const getSceneBackground = (category) => {
  const normalizedCategory = category?.toLowerCase() || 'general';
  return SCENE_BACKGROUNDS[normalizedCategory] || SCENE_BACKGROUNDS.general;
};
